import { Logger } from "~/utils";

export const resetHandler = (): void => {
  Logger.log("application reset after error");
  location.reload();
};
